module.exports = __webpack_public_path__ + "7d9160c4694d8d197a749fc9bcba53ae.png";